import gql from 'graphql-tag';

export const EVENT_HISTORY_BY_EVENT_ID = gql`
  query eventHistoryByEventId($input: EventHistoryInput!) {
    eventHistory(input: $input) {
      id
      adminId
      eventId
      oldValues
      input
      createdAt
      admin {
        id
        firstName
        lastName
        email
      }
      changes
    }
  }
`;
